import { BankAccountsResponse } from '@/types/sso';
import { useEffect, useMemo } from 'react';
import { useSso } from '../providers/SSOProvider';

export interface UseBankOptionsReturn {
    bankOptions: { label: string; value: number }[];
    bankDetails?: BankAccountsResponse;
}

const useBankOptions = (selectedCurrency, selectedBankId?): UseBankOptionsReturn => {
    const { bankInfoApi } = useSso();

    const { data: bankInfo } = bankInfoApi;

    const bankOptions = useMemo(() => {
        return bankInfo
            ? bankInfo
                  .filter((bankInfo) => {
                      if (bankInfo.active && bankInfo.status !== 'pending') {
                          if (selectedCurrency?.value) return bankInfo.baseCurrencyId === selectedCurrency.value;
                          else return true;
                      }
                  })
                  .map((bankInfo) => {
                      let fourDigits = bankInfo.accountNumber?.slice(-4);

                      if (bankInfo.accountNumber) fourDigits = bankInfo.accountNumber?.slice(-4);
                      else if (bankInfo.ibanCode) fourDigits = bankInfo.ibanCode?.slice(-4);
                      return {
                          label: `${bankInfo.friendlyName} ${fourDigits ? `****${fourDigits}` : ''}`,
                          value: bankInfo.bankInfoId
                      };
                  })
            : [];
    }, [bankInfo, selectedCurrency]);

    const bankDetails = useMemo(() => {
        return bankInfo?.find((info) => info.bankInfoId === selectedBankId?.value);
    }, [bankInfo, selectedBankId]);

    useEffect(() => {
        bankInfoApi.mutate();
    }, []);

    return { bankOptions, bankDetails };
};

export default useBankOptions;
